module.exports = __webpack_public_path__ + "img/05.44ee86e5.jpg";